<template>
    <div :class="{'cursor-pointer': link_home}" @click="clickEvent()">
        <div class="text-2xl font-semibold -mb-3" style="font-size:23px;font-family: 'Exo', sans-serif;">Creator<span class="font-bold px-1" style="color:#10B981;font-size:28px;">X</span>one</div>
        <span v-if="should_display_moto" class="font-lighter sm:contents" style="font-size:8px;">{{ $t('motto') }}</span>
    </div>
</template>

<script>
    export default {
        props: ['display_moto', 'route_home'],
        data() {
            return {
                should_display_moto: this.display_moto || false,
                link_home: this.route_home ?? true
            }
        },
        methods: {
            clickEvent() {
                console.log(this.link_home);
                if (this.link_home) {
                    this.$router.push('/');
                }
            }
        }
    }
</script>